module.exports = __webpack_public_path__ + "static/media/Around-img-1.99887c60.jpg";